<template>
    <span
        class="forum-avatar"
        :class="`forum-avatar--${size}`"
        :style="{ background: tone.bg, color: tone.color }"
        aria-hidden="true"
    >
        {{ initials }}
    </span>
</template>

<script>
    const PALETTE = [
        { bg: '#E7F8F9', color: '#0E8E96' },
        { bg: '#EEF2FF', color: '#3538CD' },
        { bg: '#F4F3FF', color: '#6927DA' },
        { bg: '#FFF6ED', color: '#C4320A' },
    ];

    export default {
        name: 'ForumAvatar',
        props: {
            name: {
                type: String,
                default: '',
            },
            size: {
                type: String,
                default: 'md',
            },
        },
        computed: {
            initials() {
                const parts = String(this.name || '')
                    .trim()
                    .split(/\s+/)
                    .filter(Boolean);
                if (!parts.length) return '?';
                if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
                return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
            },
            tone() {
                const value = String(this.name || '');
                let hash = 0;
                for (let i = 0; i < value.length; i += 1) {
                    hash = (hash + value.charCodeAt(i)) % PALETTE.length;
                }
                return PALETTE[hash];
            },
        },
    };
</script>
